import { ReportType } from '../features/reporting/providers/types';

// APP TEXT
export const APP_TITLE = 'Reveal';
export const FOOTER_TEXT = `${new Date().getFullYear()} Reveal`;
export const UNEXPECTED_ERROR_STRING = 'Unexpected error has occured.';
export const SERVER_ERROR_STRING = 'Server is not responding.';
export const UNAUTHORIZED_ERROR_STRING = 'Unauthorized request, logging out...';

// PAGES TITLE
export const PAGE_TITLE_HOME = 'Home';
export const PAGE_TITLE_PLANS = 'Plans';
export const PAGE_TITLE_ASSIGN = 'Assign';
export const PAGE_TITLE_MONITOR = 'Monitor';
export const PAGE_TITLE_ADMIN = 'Admin';

// KEYCLOAK
export const KEYCLOAK_URL = 'https://sso-ops.akros.online/auth/';
export const KEYCLOAK_REALM = 'reveal';
export const KEYCLOAK_CLIENT_ID = 'reveal-web';

//Table depth colors
export const ROW_DEPTH_COLOR_1 = '#F5F5F5';
export const ROW_DEPTH_COLOR_2 = '#E8E8E8';
export const ROW_DEPTH_COLOR_3 = '#DCDCDC';

export const USER_ROW_DEPTH_COLOR_1 = 'rgba(144,185,231,0.31)';
export const USER_ROW_DEPTH_COLOR_2 = 'rgba(202,236,255,0.8)';
export const USER_ROW_DEPTH_COLOR_3 = 'rgba(202,236,255,0.6)';

//REGEX
export const REGEX_NAME_VALIDATION = new RegExp('^[-\\a-zA-Z0-9][ a-zA-Z0-9_.-]*[^- _]$');
export const REGEX_TITLE_VALIDATION = new RegExp('^[^-\\s][a-zA-Z0-9._\\s-]*$');
export const REGEX_USERNAME_VALIDATION = new RegExp('^[a-z]+([._]?[a-z]+)*$');
export const REGEX_EMAIL_VALIDATION = new RegExp('^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$');

export const PAGINATION_DEFAULT_SIZE = 10;

export const MAPBOX_STYLE_SATELLITE = 'mapbox://styles/mapbox/satellite-v9';
export const MAPBOX_STYLE_STREETS = 'mapbox://styles/mapbox/streets-v11';
export const MAPBOX_STYLE_SATELLITE_STREETS = 'mapbox://styles/mapbox/satellite-streets-v11';
export const MAPBOX_STYLE_OUTDOOR = 'mapbox://styles/mapbox/outdoors-v12';
export const MAPBOX_STYLE_DARK = 'mapbox://styles/mapbox/dark-v10';
export const MAPBOX_STYLE_NAV_NIGHT = 'mapbox://styles/mapbox/navigation-night-v1';

export const ORGANIZATION_TABLE_COLUMNS = [
  { Header: 'name', accessor: 'name' },
  { Header: 'type', accessor: 'type' },
  { Header: 'active', accessor: 'active' }
];
export const USER_TABLE_COLUMNS = [
  { name: 'username', sortValue: 'username', accessor: 'username' },
  { name: 'firstname', sortValue: 'firstName', accessor: 'firstName' },
  { name: 'lastname', sortValue: 'lastName', accessor: 'lastName' },
  { name: 'role', sortValue: undefined, accessor: 'role' },
  { name: 'instances', sortValue: undefined, accessor: 'instances' }
];
export const BULK_TABLE_COLUMNS = [
  { name: 'fileName', sortValue: 'filename', accessor: 'filename' },
  { name: 'uploadDate', sortValue: 'uploadedDatetime', accessor: 'uploadDatetime' },
  { name: 'status', sortValue: 'status', accessor: 'status' },
  { name: 'uploadedBy', sortValue: 'username', accessor: 'uploadedBy' }
];
export const GEOGRAPHY_LEVEL_TABLE_COLUMNS = [
  { name: 'name', sortValue: 'name', accessor: 'name' },
  { name: 'title', sortValue: 'title', accessor: 'title' }
];

export const LOCATION_HIERARCHY_TABLE_COLUMNS = [
  { name: 'name', sortValue: 'name' },
  { name: 'nodeOrder', sortValue: 'nodeOrder' }
];

export const LOCATION_TABLE_COLUMNS = [
  { Header: 'Location', accessor: 'properties.name' },
  { Header: 'Geography Level', accessor: 'properties.geographicLevel' }
];

export const SIMULATION_LOCATION_TABLE_COLUMNS = [
  { Header: 'location', accessor: 'properties.name', id: 'resultName' },
  { Header: 'geographicLevel', accessor: 'properties.geographicLevel' },
  { Header: 'details', id: 'details' }
];

export const LOCATION_ASSIGN_TABLE_COLUMNS = [
  { Header: 'Location', accessor: 'properties.name', id: 'location' },
  { Header: 'Geography Level', accessor: 'properties.geographicLevel' },
  { Header: 'Select', id: 'checkbox' },
  { Header: 'Assign teams', id: 'teams' }
];

export const PLAN_TABLE_COLUMNS = [
  { name: 'planTitle', sortValue: 'title', accessor: 'title', key: 'planTitle' },
  { name: 'status', sortValue: 'status', accessor: 'status', key: 'status' },
  { name: 'interventionType', sortValue: 'interventionType', accessor: 'interventionType', key: 'name' },
  {
    name: 'locationHierarchy',
    sortValue: 'locationHierarchy',
    accessor: 'locationHierarchy',
    key: 'name'
  },
  { name: 'createDate', sortValue: 'date', accessor: 'date', key: 'createDate' },
  { name: 'startDate', sortValue: 'effectivePeriodStart', accessor: 'effectivePeriod', key: 'start' },
  { name: 'endDate', sortValue: 'effectivePeriodEnd', accessor: 'effectivePeriod', key: 'end' }
];

export const META_IMPORT_TABLE_COLUMNS = [
  { Header: 'fileName', accessor: 'filename' },
  { Header: 'uploadDate', accessor: 'uploadDatetime' },
  { Header: 'status', accessor: 'status' },
  { Header: 'uploadedBy', accessor: 'uploadedBy' },
  { Header: 'selected', accessor: 'selected' }
];

export const RESOURCE_PLANNING_HISTORY_TABLE_COLUMNS = [
  { name: 'Identifier', sortValue: 'identifier', accessor: 'identifier' },
  { name: 'Name', sortValue: 'name', accessor: 'name' },
  { name: 'Create Date', sortValue: 'created', accessor: 'created' },
  { name: 'Uploaded By', sortValue: 'createdBy', accessor: 'createdBy' }
];

export const INSTANCE_TABLE_COLUMNS = [
  {
    name: 'instanceName',
    sortValue: 'instanceName',
    accessor: 'instanceName'
  },
  {
    name: 'interventionType',
    sortValue: 'interventionType',
    accessor: 'interventionType'
  },
  {
    name: 'planTitle',
    sortValue: 'planTitle',
    accessor: 'planTitle'
  },
  {
    name: 'planStatus',
    sortValue: 'planStatus',
    accessor: 'planStatus'
  },
  {
    name: 'createdDatetime',
    sortValue: 'createdDatetime',
    accessor: 'createdDatetime'
  },
  {
    name: 'startDate',
    sortValue: 'startDate',
    accessor: 'startDate'
  },
  {
    name: 'endDate',
    sortValue: 'endDate',
    accessor: 'endDate'
  }
];

export const PLAN_MODEL_1_COLUMNS = [
  {
    name: 'instanceName',
    sortValue: 'instanceName',
    accessor: 'instanceName'
  },
  {
    name: 'interventionType',
    sortValue: 'interventionType',
    accessor: 'interventionType'
  },
  {
    name: 'planTitle',
    sortValue: 'planTitle',
    accessor: 'planTitle'
  },
  {
    name: 'planStatus',
    sortValue: 'planStatus',
    accessor: 'planStatus'
  },
  {
    name: 'createdDatetime',
    sortValue: 'createdDatetime',
    accessor: 'createdDatetime'
  },
  {
    name: 'startDate',
    sortValue: 'startDate',
    accessor: 'startDate'
  },
  {
    name: 'endDate',
    sortValue: 'endDate',
    accessor: 'endDate'
  },

];

export const LOCATION_ASSIGNMENT_TAB = 'location-assignment';
export const LOCATION_TEAM_ASSIGNMENT_TAB = 'team-assignment';
export const LOCATION_TEAM_ASSIGNMENT_SUMMARY = 'team-assignment-summary';

export const MAP_COLOR_NO_TEAMS = '#A7171A';
export const MAP_COLOR_TEAM_ASSIGNED = '#5DBB63';
export const MAP_COLOR_UNASSIGNED = '#656565';
export const MAP_COLOR_SELECTED = '#6e599f';

export const MAP_LEGEND_TEXT = [
  'Teams Assigned',
  'Location is assigned but no teams',
  'Unassigned Location',
  'Selected Location'
];
export const MAP_LEGEND_COLORS = [
  MAP_COLOR_TEAM_ASSIGNED,
  MAP_COLOR_NO_TEAMS,
  MAP_COLOR_UNASSIGNED,
  MAP_COLOR_SELECTED
];

export const MDA_STRUCTURE_COLOR_COMPLETE = '#A7171A';
export const MDA_STRUCTURE_COLOR_NOT_VISITED = '#5DBB63';
export const MDA_STRUCTURE_COLOR_NOT_ELIGIBLE = '#656565';
export const MDA_STRUCTURE_COLOR_SMC_COMPLETE = '#6e599f';
export const MDA_STRUCTURE_COLOR_SPAQ_COMPLETE = '#ffc107';

export const IRS_STRUCTURE_COLOR_NOT_SPRAYED = '#A7171A';
export const IRS_STRUCTURE_COLOR_SPRAYED = '#5DBB63';
export const IRS_STRUCTURE_COLOR_NOT_SPRAYABLE = '#656565';

export const MAP_MDA_STRUCTURE_LEGEND_COLORS = [
  MDA_STRUCTURE_COLOR_COMPLETE,
  MDA_STRUCTURE_COLOR_NOT_VISITED,
  MDA_STRUCTURE_COLOR_NOT_ELIGIBLE,
  MDA_STRUCTURE_COLOR_SMC_COMPLETE,
  MDA_STRUCTURE_COLOR_SPAQ_COMPLETE
];

export const MAP_IRS_STRUCTURE_LEGEND_COLORS = [
  IRS_STRUCTURE_COLOR_NOT_SPRAYED,
  IRS_STRUCTURE_COLOR_SPRAYED,
  IRS_STRUCTURE_COLOR_NOT_SPRAYABLE
];

export const REPORT_TABLE_PERCENTAGE_HIGH = 75;
export const REPORT_TABLE_PERCENTAGE_MEDIUM = 50;
export const REPORT_TABLE_PERCENTAGE_LOW = 25;

export const MAP_DEFAULT_FILL_OPACITY = 0.25;
export const MAP_DEFAULT_DISABLED_FILL_OPACITY = 0.85;

export const COLOR_YELLOW = '#ffff68';
export const COLOR_BOOTSTRAP_SUCCESS = '#198754';
export const COLOR_BOOTSTRAP_DANGER = '#dc3545';
export const COLOR_BOOTSTRAP_WARNING = '#ffc107';

export const NUMBER_AGGREGATION = ['sum', 'average', 'min', 'max', 'median'];
export const BOOLEAN_STRING_AGGREGATION = ['count'];
export const DATA_AGGREGATION = ['min', 'max', 'count'];

export const KEY_INDICATOR_LEVELS: any[string] = {
  //Add new entry here for customization
  [ReportType.MDA_LITE_COVERAGE]: {
    DANGER: {
      colorName: 'red',
      min: 0,
      max: 65,
      class: 'bg-danger',
      color: COLOR_BOOTSTRAP_DANGER,
      highest: false
    },
    GOOD: {
      colorName: 'yellow',
      min: 65,
      max: 80,
      class: 'bg-yellow',
      color: COLOR_YELLOW,
      highest: false
    },
    EXCELLENT: {
      colorName: 'green',
      min: 80,
      max: 100,
      class: 'bg-success',
      color: COLOR_BOOTSTRAP_SUCCESS,
      highest: true
    }
  },
  [ReportType.SURVEY]: {
    DANGER: {
      colorName: 'green',
      min: 0,
      max: 1,
      class: 'bg-success',
      color: COLOR_BOOTSTRAP_SUCCESS,
      highest: false
    },
    GOOD: {
      colorName: 'yellow',
      min: 1,
      max: 5,
      class: 'bg-yellow',
      color: COLOR_YELLOW,
      highest: false
    },
    EXCELLENT: {
      colorName: 'red',
      min: 5,
      max: 100,
      class: 'bg-danger',
      color: COLOR_BOOTSTRAP_DANGER,
      highest: true
    }
  },
  [ReportType.DEFAULT]: {
    DANGER: {
      colorName: 'red',
      min: 0,
      max: 25,
      class: 'bg-danger',
      color: COLOR_BOOTSTRAP_DANGER,
      highest: false
    },
    MEDIUM: {
      colorName: 'orange',
      min: 25,
      max: 50,
      class: 'bg-warning',
      color: COLOR_BOOTSTRAP_WARNING,
      highest: false
    },
    GOOD: {
      colorName: 'yellow',
      min: 50,
      max: 75,
      class: 'bg-yellow',
      color: COLOR_YELLOW,
      highest: false
    },
    EXCELLENT: {
      colorName: 'green',
      min: 75,
      max: 100,
      class: 'bg-success',
      color: COLOR_BOOTSTRAP_SUCCESS,
      highest: true
    }
  }
};
